import { combineReducers } from 'redux';
import type { Action } from 'state/actions';

import type { BatchFeesAndMetricsFieldState, BatchFeesAndMetricsState, BatchFormState } from '.';
import * as actionTypes from './batchForm.actionTypes';
import { infosReducer } from './infos/infos.reducer';
import { metaDataReducer } from './metaData';
import { quoteDetailsReducer } from './quoteDetails/quoteDetails.reducer';

const initialFeesAndMetricsFieldState: BatchFeesAndMetricsFieldState = {
  isExpanded: false,
  activeDataSet: 'fees',
};

function feesAndMetricsReducer(
  state: BatchFeesAndMetricsState = initialFeesAndMetricsFieldState,
  action: Action,
): BatchFeesAndMetricsState {
  switch (action.type) {
    case actionTypes.BATCH_FEES_AND_METRICS_EXPANSION_TOGGLED: {
      return {
        ...state,
        isExpanded: !state.isExpanded,
      };
    }
    case actionTypes.BATCH_FEES_AND_METRICS_DATA_SET_CHANGED: {
      return {
        ...state,
        activeDataSet: action.dataSet,
      };
    }
    default:
      return state;
  }
}

export const batchFormReducer = combineReducers<BatchFormState>({
  infos: infosReducer,
  quoteDetails: quoteDetailsReducer,
  metaData: metaDataReducer,
  feesAndMetrics: feesAndMetricsReducer,
});
